import React from 'react';

export const MetricsCatalogTab: React.FC = () => (
  <div className="space-y-4">
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-slate-950 shadow-sm">
      <iframe
        title="SmartCHG Metrics Catalog"
        src="/smartchg-metrics-catalog.html"
        className="h-[78vh] w-full"
      />
    </div>
  </div>
);
